<template lang="pug">
  app-layout
    v-flex(xs12)
      v-container.py-0.elevation-1.white(fluid)
        v-tabs(slider-color='primary')
          ld-gated-tab(
            v-for="item in items"
            :key="item.route.name"
            :to="item.route"
            :feature="item.feature"
          ) {{ item.text }}
          v-spacer.grow
          ld-how-it-works(
            :feature="routeNameMeta"
          )
      slot
</template>

<script>
import { LdGatedTab, LdHowItWorks } from 'lion-vue';
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapUserActions, mapState: mapUserState } = createNamespacedHelpers('userInformation');

const TAB_ITEMS = [
  { route: { name: 'leadsplusreporting' }, text: 'DASHBOARD' },
  { route: { name: 'leadsplusreporting.bonusleads' }, text: 'BONUS LEADS' },
  { route: { name: 'leadsplusreporting.accountmanagement' }, text: 'ACCOUNT MANAGEMENT' },
];
export default {
  components: {
    LdGatedTab,
    LdHowItWorks,
  },
  computed: {
    ...mapUserState(['user']),
    routeNameMeta() {
      return this.$route.meta.howToVideoFeature;
    },
  },
  methods: {
    ...mapUserActions(['getUser']),
  },
  async mounted() {
    if (!this.user) {
      await this.getUser();
    }
  },
  data() {
    return {
      items: TAB_ITEMS,
    };
  },
};
</script>
